import { Style } from 'index';

const DynamicFormStyles: Style = {
    input: {
        marginBottom: '1rem',
        padding: '10px 20px',
    },
};

export default DynamicFormStyles;
